const cn = {
  message: {
    Save_cmd: '存档',
    Close_cmd: '关闭窗口',
    Del_cmd: '删除',
    Query_cmd: '查询',
    Send_cmd: '确认送出',
    Sign_in: '登入',
    Sign_Out: '注销',
    Lang_txt: '语言',
    Confirm_txt: '确定',
    Load_txt: '载入中',
    Error_txt: '错误',
    Success_txt: '成功',
    Warning_txt: '警告',
    Info_txt: '消息',
    Upload_txt: '点击上传',
    Back_txt: '上一步',
    Next_txt: '下一步',
    Keep_txt: '资料暂存',
    Check_txt: '资料检查',
    Report_txt: '报表',
    Excel_txt: '电子表格',
    Edit_txt: '编辑',   
    Calc_txt: '计算',
    Anno_txt: '最新公告',
    Cancel_txt: '取消',
    DateTime_txt: '选择日期时间',
    New_txt: '新增',
    Contacts_txt: '联络我们',
    NCUT_txt: '勤益科大',
    ID_txt: '账号',
    PassW_txt: '密码',
    ValiC_txt: '验证码',
  }
}
export default cn
